export default __webpack_public_path__ + "static/media/pencil.fb6cf32c.svg";